import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { AuthGuardService } from './services/activate.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private authGuard: AuthGuardService
  ) {}

  ngOnInit() {
    // 認証チェックはAuthGuardServiceとルーティング設定で行うため、
    // AppComponentでは追加のリダイレクト処理を行わない
    // ルーティングモジュール (app-routing.module.ts) で既に以下が定義されている:
    // - ルートパス ('') は 'home' にリダイレクト
    // - 'home' は 'auth/member' にリダイレクト
    // - 未認証ユーザーは AuthGuardService でログインページにリダイレクト
    console.log('✅ AppComponent initialized, routing handled by RouterModule');

    // ルーティングイベントを監視
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      console.log('🧭 Navigation completed:', event.urlAfterRedirects);
    });
  }
}
